
import React from "react";
import {
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import Header from "components/Headers/Header.js";
import logoZoo from "assets/img/logo-zoo.png";
import Api from "shared/resources/Api";
import Util from "shared/services/Util";

class Index extends React.Component {
  state = {
    os: [],
    loading: true,
  };

  columns = [
    {
      name: "O.S",
      selector: "id",
      sortable: true,
    },
    {
      name: "Origem",
      selector: "origem",
      sortable: true,
      cell: (row) => {
        const origemValue = row.origem;
        let displayedText = "";

        switch (origemValue) {
          case "drones":
            displayedText = "Monitoramento";
            break;
          case "email":
            displayedText = "E-mail";
            break;
          case "faleconosco":
            displayedText = "Fale Conosco";
            break;
          case "municepe":
            displayedText = "Munícipe";
            break;
          case "origem_tecnica":
            displayedText = "Origem Técnica";
            break;
          case "ouvidoria":
            displayedText = "Ouvidoria";
            break;
          case "sim":
            displayedText = "SIM";
            break;
          case "telefone":
            displayedText = "Telefone";
            break;
          case "aplicativo":
            displayedText = "Aplicativo";
            break;
          default:
            displayedText = "Desconhecida";
            break;
        }

        return <div>{displayedText}</div>;
      },
    },
    {
      name: "Equipe",
      selector: "equipe",
      sortable: true,
      cell: (row) => (
        <div>{row.equipe ? Util.formatEquipe2(row.equipe) : "-"}</div>
      ),
    },
    {
      name: "Endereço",
      selector: "endereco.logradouro",
      sortable: true,
      cell: (row) => <div>{row.endereco ? row.endereco.logradouro : "-"}</div>,
      wrap: true,
    },
    {
      name: "Numero",
      selector: "numero",
      sortable: true,
      cell: (row) => <div>{row.endereco ? row.endereco.numero : "-"}</div>,
    },
    {
      name: "Bairro",
      selector: "bairro",
      sortable: true,
      cell: (row) => <div>{row.endereco ? row.endereco.bairro : "-"}</div>,
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => <div>{Util.capitalize(row.status)}</div>,
    },
    {
      name: "Data Abertura",
      selector: "data_abertura",
      sortable: true,
      cell: (row) => (
        <div>{moment(moment(row.data_abertura)).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      name: "Agendamento",
      selector: "agendamento",
      sortable: true,
      cell: (row) => (
        <div>
          {this.handleAgendamento(
            row.agendamento
              ? moment(moment(row.agendamento)).format("DD/MM/YYYY")
              : "-"
          )}
        </div>
      ),
    },
    {
      name: "Tipo",
      selector: "tipo",
      sortable: true,
      cell: (row) => {
        if (row.tipo === "solicitacao") {
          const selectedValue = row.tipo_de_imovel;
          let displayedText = "";

          switch (selectedValue) {
            case "via_publica":
              displayedText = "Via Pública";
              break;
            case "recolhimento":
              displayedText = "Recolhimento";
              break;
            case "peixes":
              displayedText = "Tratamento Biológico";
              break;
            case "obras":
              displayedText = "Canteiros de Obra";
              break;
            case "imovel_abandonado":
              displayedText = "Imóvel Abandonado";
              break;
            case "imobiliarias":
              displayedText = "Imobiliárias";
              break;
            case "focos":
              displayedText = "Focos do Mosquito";
              break;
            case "piscinas":
              displayedText = "Cadastrar Piscina";
              break;
            case "caixa_dagua":
              displayedText = "Caixas d'Água";
              break;
            case "residencia":
              displayedText = "Residência";
              break;
            default:
              break;
          }

          return <div>{Util.capitalize(displayedText)}</div>;
        } else {
          return <div>{Util.capitalize(row.tipo)}</div>;
        }
      },
    },
    {
      name: "Imobiliarias",
      selector: "imobiliarias",
      sortable: true,
      cell: (row) => (
        <div>
          {row.imobiliarias && row.imobiliarias.length > 0
            ? this.getImobiliariasNomes(row.imobiliarias)
            : "-"}
        </div>
      ),
    },
    {
      name: "Data Ult. Movimentação",
      selector: "Data Ult. Movimentação",
      sortable: true,
      cell: (row) => {
        const horario = row.acoes
          ? row.acoes.map((acao) => new Date(acao.horario)).sort((a, b) => b - a)[0]
          : null;
        return (
          <div>
            {horario
              ? horario.toLocaleString("pt-BR", {
                  timeZone: "America/Sao_Paulo",
                  dateStyle: "short",
                  timeStyle: "short",
                })
              : "N/A"}
          </div>
        );
      },
    },
    {
      name: "",
      cell: (row) => (
        <div>
          <Button
            style={{ marginLeft: "2.0rem" }}
            type="button"
            className="btn-acao "
            title="Editar"
            onClick={() => {
              this.props.history.push("/admin/ticket-edit", {
                selectedOs: row,
              });
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
          </Button>
        </div>
      ),
    }
  ];

  customStyles = {
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
      },
    },
  };

  handleAgendamento = (text) => {
    if (text === "-") {
      return <label style={{ paddingTop: "19%" }}>{text}</label>;
    } else {
      return (
        <label
          style={{ color: "#5cb85c", paddingTop: "19%", fontWeight: "bold" }}
        >
          {text}
        </label>
      );
    }
  };

  getImobiliariasNomes = (imobiliariasIds) => {
    if (!imobiliariasIds || imobiliariasIds.length === 0) {
      return "-";
    }

    const nomes = imobiliariasIds
      .map((id) => {
        const item = this.state.imobiliarias?.find((x) => x.id === id);
        return item ? item.nome : null;
      })
      .filter((nome) => nome !== null);

    return nomes.length > 0 ? nomes.sort().join(", ") : "-";
  };

  handleDelete = (element) => {
    this.setState({
      swal: {
        show: true,
        title: "Atenção",
        text: "Deseja realizar a exclusão deste registro?",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: true,
      },
      os: element,
      isConfirmation: true,
    });
  };

  componentDidMount() {
    this.fetchOsData();
  }

  fetchOsData = async () => {
    try {
      const dataFim = moment().add(30, "days").format("YYYY-MM-DD");
      const dataInicio = moment().subtract(15, "days").format("YYYY-MM-DD");

      let params = {
        agendamento_inicio: dataInicio,
        agendamento_fim: dataFim,
        status: "andamento",
        
      };
      if(localStorage.getItem('perm') != 'coordenador'){
        params.agente = localStorage.getItem('userId'); 
      }

      let esc = encodeURIComponent;
      let query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");
      //localStorage.getItem('perm') === 'coordenador'

      const response = await fetch(
        Api.baseURL + `/os?status=&${query}`,
        {
          headers: {
            Authorization: localStorage.getItem("agToken"),
          },
        }
      );

      const body = await response.json();

      this.setState({
        os: body,
        loading: false,
      });
    } catch (error) {
      console.error("Erro ao buscar OS:", error);
      this.setState({ loading: false });
    }
  };
 
  render() {
    return (
      <>
        <Header />
        {/* Page content */}
        <Container>
              <div className="header-body text-center mb-7 mt-5">
                <Row className="justify-content-center">
                  <Col lg="5" md="6">
                    <img
                      src={logoZoo}
                      width="300"
                      alt="logo udi sem dengue"
                    />
                  </Col>
                </Row>
                
                  <Row className="mt-5">
                    <Col>
                      <h3 className="text-dark">Ordens de Serviço - Últimos 15 Dias</h3>
                      <div>
                        <DataTable
                          columns={this.columns}
                          data={this.state.os}
                          pagination
                          progressPending={this.state.loading}
                          progressComponent={<div>Carregando...</div>}
                          noDataComponent={<div>Nenhum resultado encontrado</div>}
                          customStyles={this.customStyles}
                        />
                      </div>
                    </Col>
                  </Row>
                 
              </div>
            </Container>
      </>
    );
  }
}

export default Index;
